import { render, staticRenderFns } from "./page_404.vue?vue&type=template&id=85236948&scoped=true&"
import script from "./page_404.vue?vue&type=script&lang=js&"
export * from "./page_404.vue?vue&type=script&lang=js&"
import style0 from "./page_404.vue?vue&type=style&index=0&id=85236948&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85236948",
  null
  
)

export default component.exports